import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { compose, ReduxWrapper } from 'common-data/datahelpers'

import styles from './DataCardMessage.less'

class DataCardMessagePlain extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any
  })

  render () {
    const { children } = this.props

    if (children) {
      return (
        <div className={styles.datacard}>
          {children}
        </div>
      )
    } else {
      return null
    }
  }
}

export const DataCardMessage = compose(
  ReduxWrapper([
  ],
  [])
)(DataCardMessagePlain)
